import type React from 'react';
import { type CostGroupSection, CostGroupSettings } from './CostGroupSettings';

interface CostGroupsSettingsPageProps {
  section: CostGroupSection;
}

export const CostGroupsSettingsPage: React.FC<CostGroupsSettingsPageProps> = ({ section }) => {
  return (
    <div className="p-2">
      <CostGroupSettings section={section} />
    </div>
  );
};
